import React from "react";
import Tree from "rc-tree";
import "rc-tree/assets/index.css";
import { useTranslation } from "react-i18next";

const actionKeys = ["add", "save", "delete", "search", "print", "edit", "preview"];
const localizeActions = (nodes = [], t) =>
  nodes.map((node) => {
    const localizedNode = {
      ...node,
      name: actionKeys.includes(node.name) ? t(node.name) : node.name,
    };

    if (node.children) {
      localizedNode.children = localizeActions(node.children, t);
    }

    return localizedNode;
  });

const UserPermissionsTree = (props) => {
  const { data, setCheckedKeys, defaultCheckedKeys } = props;
  const { t } = useTranslation(["forms"]);
  const localizedData = React.useMemo(() => localizeActions(data, t), [data, t]);
  const onCheck = (checkedKeys, info) => {
    console.log("the checked keys is", checkedKeys);
    console.log("the checked keys is", info);
    setCheckedKeys(checkedKeys);
    // onShow(data, "edit");
  };
  const fieldNames = {
    title: "name",
    key: "id",
    children: "children",
  };

  return (
    <div style={{ margin: "0 20px" }}>
      {/* <IconButton
        variant="contained"
        edge="start"
        color="inherit"
        aria-label="home"
        onClick={() => {
          setExpandAll(true);
        }}
      >
        <UnfoldLess />{" "}
      </IconButton>
      <IconButton
        variant="contained"
        edge="start"
        color="inherit"
        aria-label="home"
        onClick={() => {
          setExpandAll(false);
          console.log(expandAll);
        }}
      >
        <UnfoldMore />{" "}
      </IconButton> */}
      <Tree
        checkable
        selectable={false}
        checkStrictly={false}
        defaultCheckedKeys={defaultCheckedKeys}
        // defaultExpandedKeys={[1, 2, 3, 4]}
        defaultExpandAll={false}
        onCheck={onCheck}
        defaultExpandParent={true}
        className="myCls"
        fieldNames={fieldNames}
        treeData={localizedData}
      />
    </div>
  );
};

export default UserPermissionsTree;
